import ApiClient from '../ApiClient';

const WhatsAppTemplateService = {
     async getAllWhatsAppTemplates(queryParams) {
        const resp = await ApiClient.get('/Whatsapp/whatsapp-template-list', {
          params: queryParams,
        });
        return resp;
    },

    async getWhatsAppTemplateById(id) {
        const resp = await ApiClient.get(`/Whatsapp/templates/${id}`);
        return resp;
    },

    async saveWhatsAppTemplate(payload) {
                const resp = await ApiClient.post('/Whatsapp/save-whatsapp-template', payload);
                return resp;
    },

    async editWhatsAppTemplate(payload) {
                const resp = await ApiClient.post('/Whatsapp/edit-whatsapp-template', payload);
                return resp;
    },

    async deleteWhatsAppTemplate(id) {
        const resp = await ApiClient.delete(`/Whatsapp/delete-whatsapp-template/${id}`);
        return resp;
    },

    async syncFromMeta() {
                const resp = await ApiClient.post('/Whatsapp/sync-from-meta');
                return resp;
    },
    
     async getApprovedTemplates() {
        const resp = await ApiClient.get(`/Whatsapp/templates`);
        return resp;
    },
};

export default WhatsAppTemplateService;